import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorPage } from '@/components/errors';

const genericErrorSearchSchema = z.object({
  message: z.string().optional(),
  stack: z.string().optional(),
});

export const Route = createFileRoute('/error/generic')({
  component: GenericErrorPage,
  validateSearch: genericErrorSearchSchema,
});

function GenericErrorPage() {
  const { message, stack } = Route.useSearch();

  return <ErrorPage message={message} stack={stack} />;
}
